export default __webpack_public_path__ + "static/media/kabupaten-kulonprogo.32d427f3.png";